import React from "react";
import { Modal } from "react-bootstrap";
import { MdClose, MdVisibility } from "react-icons/md";
import { HeaderProps } from "../../../@types/organ";
import { BoxCloseModal, Content, HeaderModal, Info, TitleModal } from "./style";
interface Props {
  show: boolean;
  handleShow: () => void;
  data: HeaderProps;
}
const ModalInformationHeader = ({ show, handleShow, data }: Props) => {
  return (
    <Modal show={show} onHide={handleShow} centered size="lg">
      <HeaderModal>
        <Info>
          <MdVisibility size={22} />
          <TitleModal>{data.titulo}</TitleModal>
        </Info>
        <BoxCloseModal onClick={handleShow}>
          <MdClose size={22} />
        </BoxCloseModal>
      </HeaderModal>
      <Modal.Body>
      <Content
          className="prose max-w-full"
          dangerouslySetInnerHTML={{
            __html: data.conteudo.replace(
              /<img /g,
              '<img style="max-width: 100%; height: auto;" '
            ),
          }}
        ></Content>
      </Modal.Body>
    </Modal>
  );
};

export default ModalInformationHeader;
